export enum ProductApiType {
  PRODUCT_LINE = 1,
  PRODUCT_JOURNEY = 2,
  COLOR_JOURNEY = 3,
}
